import Vue from 'vue'
import axios from '@/plugins/axios'
import { Message } from 'element-ui'

const mixin = Vue.mixin({
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' }
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ['link', 'image', 'video']
      ],
      dateRangeOptions: {
        shortcuts: [
          {
            text: 'Today',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Last week',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Last month',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      window: {
        width: 0
      },
      tiers: [
        { value: 0, name: 'Free' },
        { value: 1, name: 'Bronze' },
        { value: 2, name: 'Silver' },
        { value: 3, name: 'Gold' }
      ],
      permissions: [
        { value: 1, name: 'Level 1' },
        { value: 2, name: 'Level 2' },
        { value: 3, name: 'Level 3' }
      ],
      track_type: [
        { value: 'general', name: 'General' },
        { value: 'challenge', name: 'Challenge TikTok' },
        { value: 'short_challenge', name: 'Challenge Shorts' },
        { value: 'nft', name: 'NFT' }
      ],
      bands: [
        { value: 'A', name: 'A' },
        { value: 'B', name: 'B' }
      ]
    }
  },

  methods: {
    async logout(userType) {
      try {
        const logoutUser = await axios[userType].post('user/logout')
        if (logoutUser.data.success) {
          localStorage.removeItem('token')

          this.$store.commit('auth/setUser', null)
          await this.$router.push('/auth/login')
        }
      } catch (e) {
        Message({ type: 'error', message: 'Something went wrong' })
      }
    },
    ascDesc(order) {
      switch (order) {
        case 'ascending':
          return 'asc'
        case 'descending':
          return 'desc'
        default:
          return order
      }
    },
    commaNum(number, dec, dsep, tsep) {
      if (isNaN(number) || number == null) return ''

      number = parseFloat(number).toFixed(~~dec)
      tsep = typeof tsep === 'string' ? tsep : ','

      // eslint-disable-next-line one-var
      var parts = number.split('.'),
        fnums = parts[0],
        decimals = parts[1] ? (dsep || '.') + parts[1] : ''

      return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals
    },
    commaNumTable(row, column, cellValue) {
      return this.commaNum(cellValue)
    },
    resizeImageBase64(base64Str, maxWidth = 1080, maxHeight = 1920) {
      let img = new Image()
      img.src = base64Str
      img.onload = () => {
        let canvas = document.createElement('canvas')
        const MAX_WIDTH = maxWidth
        const MAX_HEIGHT = maxHeight
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        this.img = canvas.toDataURL('image/jpeg')
      }
    },
    sum(array) {
      return array.reduce(function(a, c) {
        return a + c.video
      }, 0)
    },
    windowWidth() {
      this.window.width = window.innerWidth
    },
    tierType(tier) {
      switch (tier) {
        case 0:
          return 'success'
        case 1:
          return 'warning'
        case 2:
          return 'info'
        case 3:
          return 'warning'
        default:
          return 'danger'
      }
    },
    tierName(tier) {
      switch (tier) {
        case 0:
          return 'Free'
        case 1:
          return 'Bronze'
        case 2:
          return 'Silver'
        case 3:
          return 'Gold'
        default:
          return 'No tier'
      }
    },
    typeName(type) {
      switch (type) {
        case 'user':
          return 'Creator User'
        case 'creator':
          return 'Verified Creator'
        default:
          return type
      }
    }
  }
})

export default mixin
